"use client";

import type React from "react";
import type { FooterLinkProps } from "../../types/footer-links";

import { scrollToTop } from "@homeinstead/shared";
import { useCallback } from "react";
import { FooterLink } from "./FooterLink";

type OsanoCookieButtonProps = Omit<FooterLinkProps, "href" | "onClick">;

/**
 * A button that triggers the Osano cookie consent manager drawer when clicked.
 */
const OsanoCookieButton = ({ children, ...props }: OsanoCookieButtonProps) => {
  const handleOsanoClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();

    scrollToTop();

    if (window.Osano?.cm) {
      window.Osano.cm.showDrawer("osano-cm-dom-info-dialog-open");
    } else {
      console.error("Osano is not initialized yet.");
    }
  }, []);

  return (
    <FooterLink href="#" {...props} onClick={handleOsanoClick}>
      {children}
    </FooterLink>
  );
};

export { OsanoCookieButton };
